import { SegmentCreatorItem } from './SegmentCreatorItem';
import { groupQueryDataByGroupId } from '@insights_module/adc_ql/utils';
import {
  SegmentCreatorData,
  useSegmentCreatorContext,
} from '@insights_module/context/SegmentCreatorContext';

function buildSegmentItems(
  queryGroupMap: Map<string | null, SegmentCreatorData[]>,
  groupId: string | null = null
) {
  const currentGroup = queryGroupMap.get(groupId);

  if (!currentGroup) return [];

  return currentGroup.flatMap((input) => {
    let children = [] as JSX.Element[] | null;
    if (input.type === 'all' || input.type === 'any') {
      // Recursively build children for composite segments
      children = buildSegmentItems(queryGroupMap, input.id);
    }

    return (
      <SegmentCreatorItem id={input.id} key={input.id}>
        {children}
      </SegmentCreatorItem>
    );
  });
}

export const SegmentCreatorUIBuilder = () => {
  const { segmentsData } = useSegmentCreatorContext();
  const mappedData = groupQueryDataByGroupId(segmentsData);
  const segmentItems = buildSegmentItems(mappedData);

  return <div>{segmentItems}</div>;
};
